module.exports = __webpack_public_path__ + "img/avatar_pic_community_n.d99e7d59.png";